import {lazy} from 'react';

export const AiToolsRoutes = [{
    label: 'ai工具箱',
    key: 'ai-tools',
    show: false,
    path: '/ai-tools',
    element: lazy(() => import('@/components/Layout/AiToolsLayout')),
    children: [
        {
            label: '列表',
            key: 'list',
            show: false,
            path: 'list',
            element: lazy(() => import('@/page/AiTools/list'))
        },
        {
            label: '详情',
            key: 'detail',
            show: false,
            path: 'detail/:id',
            element: lazy(() => import('@/page/AiTools/detail'))
        }
    ]
}];